export function canPaste() {
    return "readText" in navigator.clipboard;
}
export const clipboardKey = "copiedClipboard";
//# sourceMappingURL=commons.js.map